export const SETTINGS_MENU_PATH = "/settings-menu";
